// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Mint from 'mint-ui'
import ViewUI from 'view-design';
import axios from 'axios'
import config from './config';
import util from './utils/util'

import 'lib-flexible'
// px2rem
// window.onresize = setHtmlFontSize
// function setHtmlFontSize () {
//   const htmlWidth = document.documentElement.clientWidth || document.body.clientWidth
//   const htmlDom = document.getElementsByTagName('html')[0]
//   htmlDom.style.fontSize = htmlWidth / 10 + 'px'
// }
// setHtmlFontSize()

import 'mint-ui/lib/style.css';
import 'view-design/dist/styles/iview.css';
import './css/global.css'

Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.$config = config
Vue.prototype.$util = util
Vue.use(Mint)
Vue.use(ViewUI);

Vue.prototype.$post = function (url, params, successc, failc, silence = false) {
  params = params || {};
  if (!silence) {
    this.$indicator.open("请求中...");
  }
  this.$axios
    .post(url, params)
    .then(res => {
      if (!silence) {
        this.$indicator.close();
      }
      if (res.data.err) {
        failc && failc(res.data.data);
        return this.$toast(res.data.msg);
      }
      successc && successc(res.data.data);
    })
    .catch(e => {
      console.log(e);
      this.$toast("请求失败");
      if (!silence) {
        this.$indicator.close();
      }
    });
}

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  } else {
    document.title = "VR学车引领者 - 厦门游仁信息科技有限公司 - 官网";
  }
  next()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js